import { render } from "./TestesIndependentes.vue?vue&type=template&id=4b2b4b2e&scoped=true"
import script from "./TestesIndependentes.vue?vue&type=script&lang=js"
export * from "./TestesIndependentes.vue?vue&type=script&lang=js"

import "./TestesIndependentes.vue?vue&type=style&index=0&id=4b2b4b2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2b4b2e"]])

export default __exports__